import React from "react";

const AimantraLoading = () => {
  return (
    <div className="aimantra-loading-container">
      <style>{`
        .aimantra-loading-container {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 400px;
          position: relative;
          overflow: hidden;
        }

        .loading-wrapper {
          position: relative;
          width: 200px;
          height: 200px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* Outer rotating ring */
        .loading-ring {
          position: absolute;
          width: 180px;
          height: 180px;
          border: 3px solid transparent;
          border-top: 3px solid #0066ff;
          border-right: 3px solid #c41e3a;
          border-radius: 50%;
          animation: spinRing 3s linear infinite;
        }

        /* Inner pulsing ring */
        .loading-pulse-ring {
          position: absolute;
          width: 160px;
          height: 160px;
          border: 2px solid transparent;
          border-image: linear-gradient(45deg, #0066ff, #c41e3a) 1;
          border-radius: 50%;
          animation: pulseRing 2s ease-in-out infinite;
        }

        /* Logo wrapper */
        .logo-wrapper {
          position: relative;
          z-index: 10;
          width: 120px;
          height: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: rotateLogoX 4s ease-in-out infinite;
        }

        .logo-wrapper img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          filter: drop-shadow(0 0 20px rgba(0, 102, 255, 0.3));
        }

        /* Orbiting particles */
        .particle {
          position: absolute;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          animation: orbitParticle 6s linear infinite;
        }

        .particle:nth-child(1) {
          background: #0066ff;
          animation-delay: 0s;
          left: 50%;
          top: 10px;
          transform-origin: 0 90px;
        }

        .particle:nth-child(2) {
          background: #c41e3a;
          animation-delay: 2s;
          left: 50%;
          top: 10px;
          transform-origin: 0 90px;
        }

        .particle:nth-child(3) {
          background: #0066ff;
          animation-delay: 4s;
          left: 50%;
          top: 10px;
          transform-origin: 0 90px;
        }

        /* Progress bar */
        .progress-bar {
          position: absolute;
          bottom: -40px;
          width: 150px;
          height: 4px;
          background: #e8e8f0;
          border-radius: 2px;
          overflow: hidden;
          left: 50%;
          transform: translateX(-50%);
        }

        .progress-fill {
          height: 100%;
          background: linear-gradient(90deg, #0066ff, #c41e3a);
          animation: progressFill 2s ease-in-out infinite;
        }

        /* Loading text */
        .loading-text {
          position: absolute;
          bottom: -70px;
          width: 200px;
          text-align: center;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
          font-size: 14px;
          color: #0066ff;
          font-weight: 500;
          letter-spacing: 2px;
          animation: textPulse 1.5s ease-in-out infinite;
        }

        /* Animations */
        @keyframes spinRing {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes pulseRing {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.1);
            opacity: 0.6;
          }
        }

        @keyframes rotateLogoX {
          0% {
            transform: rotateX(0deg) rotateY(0deg);
          }
          50% {
            transform: rotateX(20deg) rotateY(360deg);
          }
          100% {
            transform: rotateX(0deg) rotateY(720deg);
          }
        }

        @keyframes orbitParticle {
          from {
            transform: rotate(0deg) translateX(90px) scale(1);
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
          to {
            transform: rotate(360deg) translateX(90px) scale(0.5);
            opacity: 0;
          }
        }

        @keyframes progressFill {
          0% {
            width: 0%;
          }
          50% {
            width: 100%;
          }
          100% {
            width: 0%;
          }
        }

        @keyframes textPulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>

      <div className="loading-wrapper">
        <div className="loading-ring"></div>
        {/* <div className="loading-pulse-ring"></div> */}

        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>

        <div className="logo-wrapper">
          <img
            src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/logo-TrdLCy9dLO4dX538BJaWZ9tHupEX7z.png"
            alt="Loading..."
          />
        </div>

        <div className="progress-bar">
          <div className="progress-fill"></div>
        </div>

        <div className="loading-text">LOADING</div>
      </div>
    </div>
  );
};

export default AimantraLoading;
